import React, { useCallback } from "react";
import { I18n, translateMarkupString } from "@td/shared_utils";
import { useModal } from "../ModalProvider";
import { MODAL_TYPES } from "../../constants/modal-types";
import Link from "../Link";
import MemberPhones from "../MemberPhones";
import styles from "./styles.module.scss";

const Footer = () => {
  const { openModal } = useModal();

  const handleOpenModal = useCallback(() => {
    openModal(MODAL_TYPES.AUDIO_TEST);
  }, [openModal]);

  return (
    <React.Fragment>
      <div className={styles.helpContainer}>
        <Link
          onClick={handleOpenModal}
          data-testid="auto-dialer-footer-audio-test-button"
        >
          <I18n scope="autodialer.call_interface.footer" text="test_audio_cta" />
        </Link>

        <div className={styles.divider}>
          |
        </div>

        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://communications.teladoc.com/resources/video_support/Provider_Audio_FAQ_Document.pdf"
          data-testid="auto-dialer-footer-audio-faq-link"
        >
          <I18n scope="autodialer.call_interface.footer" text="faq" />
        </Link>
      </div>

      <div
        className={styles.technicalIssues}
        data-testid="auto-dialer-footer-technical-issues"
      >
        {translateMarkupString("autodialer.call_interface.fallbacks", "troubleshooting_html", { b: <b /> })}
      </div>

      <MemberPhones />
    </React.Fragment>
  );
};

Footer.displayName = "Footer";

export default Footer;
